import store from '../store'


export let document = {
  cartorio_id: store.getters['auth/getCartorioId'],
  pessoa: {
    cpf: null,
    nome: null,
    sexo: 'Masculino',
    grupo_sanguineo: null,
    data_nascimento: null,
    falecido: true,
    estado_civil: 'SOLTEIRO',
    cor_pele: null,
    codigo_ocupacao: null,
    ocupacao_declarada: null,
    codigo: 76,
    naturalidade: null,
    naturalidade_declarada: null,
    vedada_publicacao: null,
    uf: null,
  },
  genitores: [],
  local_ocorrencia: {
    tipo: 'hospital',
    ativo: false,
    descricao: '',
    endereco: {}
  },
  gemeos: [],
  partes: [],
  nascimento_informacao: {
    idade_mae: null,
    total_filhos_vivos_gestacoes_anteriores: null,
    total_filhos_mortos_gestacoes_anteriores: null,
    total_semanas_gestacao: null,
    // tipo_gravidez: 'ÚNICA',
    tipo_gravidez: null,
    tipo_parto: null,
    // tipo_parto: 'CESÁREO',
    total_consultas_pre_natal: null
  },
  recem_nascido: {
    indice_apgar_1_minuto: null,
    indice_apgar_5_minuto: null,
    cor_pele: null,
    peso: null,
    anomalias_ou_defeitos: null
  },
  registro: {
    numero_declaracao_nascido_vivo: '',
    tipo_registro: 'N',
    data_ocorrido: null,
    hora_ocorrido: null,
    oficial: null,
    digitador: null,
    escrevente: null,
    data_registro: null,
    termo: null,
    livro_id: null,
    folha: null,
    lado: 'FRENTE',
    matricula: null,
    acervo: null,
    dentro_prazo: true
  }
}
